import React from 'react';
import { cn } from '../lib/utils/cn';

interface CardProps {
  variant?: 'default' | 'elevated' | 'interactive';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  padding = 'md',
  className,
  children,
  onClick,
  ...props
}) => {
  const baseClasses = 'bg-white rounded-2xl transition-all duration-300';
  
  const variants = {
    default: 'border border-gray-100 shadow-sm hover:shadow-lg',
    elevated: 'shadow-lg hover:shadow-xl',
    interactive: 'border border-gray-100 shadow-sm hover:shadow-lg cursor-pointer transform hover:scale-105'
  };

  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6', 
    lg: 'p-8'
  };

  const classes = cn(
    baseClasses,
    variants[variant],
    paddings[padding],
    className
  );

  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      className={classes}
      onClick={onClick}
      {...(onClick ? { type: 'button' } : {})}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Card;